export function setCurrencySymbol(locale) {
    switch (locale) {
        case "de-DE":
        case "de-AT":
        case "es-ES":
        case "fr-FR":
        case "it-IT":
        case "nl-NL":
        case "pt-PT":
            return "EUR";
        case "en-US":
            return "USD";
        case "en-GB":
            return "GBP";
        case "pl-PL":
            return "PLN";
        case "bg-BG":
            return "BGN";
        case "en-CA":
            return "CAD";
        case "pt-BR":
            return "BRL";
        case "en-CN":
        case "zh_CN":
            return "CNY";
        case "en-IN":
            return "INR";
        case "hu-HU":
            return "HUF";
        case "ro-RO":
            return "RON";
        case "de-CH":
        case "fr-CH":
            return "CHF";
        case "en-SG":
            return "SGD";
        case "sk-SK":
            return "SKK";
        case "en-SE":
            return "SEK";
        case "tr-TR":
            return "TRL";
        case "vi-VN":
            return "VNC";
        case "cs-CZ":
            return "CZK";
        case "ru-RU":
            return "RUB";
        case "th-TH":
            return "THB";
        case "zh-TW":
            return "TWD";
        case "ja-JP":
            return "JPY";
        case "ko-KR":
            return "KRW";
    }
}
//# sourceMappingURL=setCurrencySymbol.js.map
